"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@mui/styles");

var _material = require("@mui/material");

var StyledLabelNote = (0, _styles.styled)(_material.Box)(function (_ref) {
  var palette = _ref.theme.palette;
  return {
    fontSize: '0.875rem',
    color: palette.grey.main
  };
});
var _default = StyledLabelNote;
exports.default = _default;